import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 2976EA1B-60A3-46FB-97E2-95BB74B0DD22
 * name calendar-edit
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-edit.svg
 * tags
 * - Date / Time 
 * - Edit / Modify 
 */
export const CalendarEditIcon = createSvgIcon(<><path d="M19,3H18V1H16V3H8V1H6V3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H10V19H5V8H19V9H21V5A2,2 0 0,0 19,3M21.7,13.35L20.7,14.35L18.65,12.35L19.65,11.35C19.85,11.14 20.19,11.13 20.42,11.35L21.7,12.63C21.89,12.83 21.89,13.15 21.7,13.35M12,18.94L18.07,12.88L20.12,14.88L14.06,21H12V18.94Z" /></>, 'CalendarEditIcon');
export default CalendarEditIcon